module.exports = __webpack_public_path__ + "img/blog-1.0def270b.jpg";